import Page from "@jumbo/shared/Page";
import TenantAdminRoute from "app/routes/TenantAdminRoute";
import AccessDenied from "../extra-pages/Error404/AccessDenied";
import AddNewForm from "./views/custom-forms/AddNewForm";
import Drafts from "./views/drafts/Drafts";
import Favourites from "./views/favourites/Favourites";
import AllFormsListing from "./views/forms/AllFormsListing";
import FormDetails from "./views/forms/form-details/FormDetails";
import FormsListing from "./views/forms/FormsListing";
import FormsMattersListing from "./views/forms/MattersListing";
import CreateMatter from "./views/matters/create-matter/CreateMatter";
import CreateMatterModal from "./views/matters/create-matter/CreateMatterModal";
import MattersFormsListing from "./views/matters/FormsListing";
import ImportMatter from "./views/matters/import-matter/ImportMatter";
import MatterDetails from "./views/matters/matter-details/MatterDetails";
import MattersListing from "./views/matters/MattersListing";
import Notification from "./views/notification/Notification";
import ModifyForm from "./views/preview-form/ModifyFrom";
import PreviewFavoriteForm from "./views/preview-form/PreviewFavoriteForm";
import PreviewForms from "./views/preview-form/PreviewForms";
import Category from "./views/category/Category";
import CategoryForm from "./views/category/CategoryForm";
import HelpSection from "./components/help-section/HelpSection";
import AnalyticsDashboard from "./views/analytics-dashboard/AnalyticsDashboard";
import { Navigate } from 'react-router-dom';

const isAdmin = (window.location.host.split(".")[0]).includes("admin") || process.env.NODE_ENV === "development";

const AdminOnlyAnalyticsDashboard = () => (
    localStorage.getItem("TENANT_ROLE") === "admin" ? <AnalyticsDashboard/> : <AccessDenied/>
);

const DocgenRoutes = [

    // ALL FORMS LISTING PAGE
    {
        path: "/docgen/no-data-found",
        element: <TenantAdminRoute element={<Page component={<AllFormsListing onDataFound={true} />} />} /> // onDataFound is added only for demo purpose

    },
    {
        path: "/docgen",
        element: <Navigate to="/docgen/drafts" replace/>,
    },
    {
        path: "/docgen/drafts/modify",
        element: <TenantAdminRoute element={<Page component={ModifyForm}/>} />
    },
    {
        path: "/docgen/drafts/preview",
        element: <TenantAdminRoute element={<ModifyForm isEditable={false} />} />
    },
    {
        path: "/docgen/favorite-forms/preview",
        element: <TenantAdminRoute element={<Page component={PreviewFavoriteForm}/>} />
    },
    {
        path: "/docgen/drafts",
        element: <TenantAdminRoute element={<Page component={Drafts}/>} />
    },
    {
        path: "/docgen/favourites",
        element: <TenantAdminRoute element={<Page component={Favourites}/>} />
    },
    {
        path: "/docgen/analytics-dashboard",
        element: <TenantAdminRoute element={<Page component={AdminOnlyAnalyticsDashboard}/>} />
    },
    /*{
      path: "/docgen/filing",
      element: <TenantAdminRoute element={<Page component={FilingListing}/>} />
    },
    {
      path: "/docgen/ack-awaited",
      element: <TenantAdminRoute element={<Page component={AckAwaited}/>} />
    },
    {
      path: "/docgen/workbench",
      element: <TenantAdminRoute element={<Page component={Workbench}/>} />
    },*/
    {
        path: "/docgen/form/details",
        element: <TenantAdminRoute element={<Page component={FormDetails}/>} />
    },
    // ALL FORMS LISTING PAGE

    // MATTERS PAGES
    {
        path: "/docgen/matters",
        element: <TenantAdminRoute element={<Page component={MattersListing}/>} />
    },
    {
        path: "/docgen/matters/create",
        element: <TenantAdminRoute element={<Page component={CreateMatter}/>} />
    },
    {
        path: "/docgen/matters/details",
        element: <TenantAdminRoute element={<Page component={MatterDetails}/>} />
    },
    {
        path: "/docgen/matters/forms",
        element: <TenantAdminRoute element={<Page component={MattersFormsListing}/>} />
    },
    {
        path: "/docgen/matters/preview",
        element: <TenantAdminRoute element={<Page component={PreviewForms}/>} />
    },
    {
        path: "/docgen/import",
        element: <TenantAdminRoute element={<Page component={isAdmin ? ImportMatter : AccessDenied}/>} />
    },
    // MATTERS PAGES

    // FORMS PAGES
    {
        path: "/docgen/forms",
        element: <TenantAdminRoute element={<Page component={FormsListing}/>} />
    },
    {
        path: "/docgen/forms/matters",
        element: <TenantAdminRoute element={<Page component={FormsMattersListing}/>} />
    },
    {
        path: "/docgen/forms/preview",
        element: <TenantAdminRoute element={<Page component={PreviewForms}/>} />
    },
    // FORMS PAGES
    // CUSTOM FORMS PAGE
    {
        path: "/docgen/custom-form",
        element: <TenantAdminRoute element={<Page component={AddNewForm}/>}/>
    },
    {
        path: "/docgen/categories",
        element: <TenantAdminRoute element={<Page component={Category}/>}/>
    },
    {
        path: "/docgen/categories/form",
        element: <TenantAdminRoute element={<Page component={CategoryForm}/>}/>
    },
    // CUSTOM FORMS PAGE
    // NOTIFICATION PAGE
    {
        path: "/docgen/notifications",
        element: <TenantAdminRoute element={<Page component={Notification}/>} />
    },
    {
        path: "/docgen/create-new-docket",
        element: <TenantAdminRoute element={<Page component={CreateMatterModal}/>} />
    },
    ///HELP SECTION
    {
        path: ["/docgen/help"],
        element: <TenantAdminRoute element={<Page component={HelpSection} />} />
    },
]


export default DocgenRoutes;